module.exports = __webpack_public_path__ + "img/img02_sp.bebbce07.jpg";